/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect, useState } from 'react';
import { InputField } from '.';

// maxFields: hoje todos os usos são telefone — limite de 3 números por causa da
// validação de WhatsApp (ChatLabs), que aceita até 3 números por pessoa.
const InputFieldGroup = ({ id, type = 'text', maskOptions, label, name, value, setValue, message, state, maxFields = 3, ...props }) => {
	const [fields, setFieldsState] = useState(value || ['']);

	useEffect(() => {
		if (Object.values(fields) != value) {
			setFieldsState(value);
		}
	}, [value]);

	const decreasefields = i => {
		if (fields.length > 1) {
			const newFields = [...fields];
			newFields.splice(i, 1);
			setFieldsState(newFields);
		}
	};

	const increasefields = () => {
		if (fields.length < maxFields) {
			setFieldsState([...fields, '']);
		}
	};

	const onFieldChange = (val, index) => {
		const newFields = [...fields];
		newFields[index] = val;
		setFieldsState(newFields);
		setValue(newFields.map(f => (['(__) ____-____', '(__) _____-____'].includes(f) ? '' : f)));
	};

	if (!Array.isArray(fields)) {
		return null;
	}

	return fields.map((field, index) => {
		let inputMessage = null;
		let inputStatus = null;
		if (message) {
			if (Array.isArray(message) && message[index]) {
				inputMessage = message[index];
				inputStatus = 'error';
			} else if (typeof message === 'string' && index === 0) {
				inputMessage = message;
				inputStatus = 'error';
			}
		}

		return (
			<div
				key={`${name}-${index}`}
				css={{
					position: 'relative',
				}}
			>
				<InputField
					state={inputStatus}
					message={inputMessage}
					{...props}
					id={id}
					type={type}
					label={label}
					maskOptions={maskOptions}
					setValue={val => onFieldChange(val, index)}
					value={field}
				/>
				<div
					css={{
						position: 'absolute',
						top: 35,
						right: 0,
						height: '50px',
						backgroundColor: 'transparent',
						borderRadius: '0 10px 10px 0',
						width: '80px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
						paddingRight: '10px',
						'i ': {
							fontSize: '1.8rem',
							marginTop: '4px',
						},
					}}
				>
					{fields.length > 1 ? (
						<button
							type="button"
							aria-label={`Remover ${label}`}
							onClick={() => decreasefields(index)}
							css={({ colors }) => ({
								width: '20px',
								height: '20px',
								borderRadius: '50%',
								backgroundColor: colors.other['orange'],
								border: 'none',
								color: colors.white,
								transition: '.2s linear',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								marginRight: 16,
								'&:hover': {
									color: colors.other['orange'],
									backgroundColor: colors.transparent,
								},
							})}
						>
							<i className="fi fi-br-minus-small"></i>
						</button>
					) : null}
					{fields.length < maxFields ? (
					<button
						type="button"
						aria-label={`Adicionar ${label}`}
						onClick={increasefields}
						css={({ colors }) => ({
							width: '20px',
							height: '20px',
							borderRadius: '50%',
							backgroundColor: colors.other['green'],
							border: 'none',
							color: colors.white,
							transition: '.2s linear',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							marginRight: 8,
							'&:hover': {
								color: colors.other['green'],
								backgroundColor: colors.transparent,
							},
						})}
					>
						<i className="fi fi-br-plus-small"></i>
					</button>
					) : null}
				</div>
			</div>
		);
	});
};

export default InputFieldGroup;
